const React = require('react')
const PropTypes = require('prop-types')
const Profile = require('./profile')
const Home = require('page/home/home')
const Error404Page = require('page/error/404')
const isUser = require('module/user/helpers/is_user')
const isLoggedIn = require('module/viewer/helpers/is_logged_in')

class ValidateUsername extends React.Component {

    // return components used in render method
    components() {
        return {
            Profile,
            Error404Page,
            Home,
            isUser,
        }
    }

    render() {
         
        const { Profile, Error404Page, Home, isUser } = this.components()
        const { user } = this.context.page
        const { viewer } = this.context
        const { params } = this.props

        // if the page.user in context matches the username in the URL, render the profile
        if (isUser(user, params.user_name)) {
            return (
                <Profile />
            )
        }

        // else we're going to render the 404 page for logged-in users
        if (isLoggedIn(viewer)) {
            return (
                <Error404Page>
                    <p>
                        There is no one by the name ‘{params.user_name}’.
                        Please check the name and try again.
                    </p>
                </Error404Page>
            )
        }

        // or the homepage for anonymous viewers
        return (
            <Home missing_user_name={params.user_name} />
        )
    }

}

ValidateUsername.propTypes = {
    params: PropTypes.shape({
        user_name: PropTypes.string.isRequired,
    }).isRequired,
}

ValidateUsername.contextTypes = {
    page: PropTypes.shape({
        user: PropTypes.object,
    }).isRequired,
    viewer: PropTypes.object,
}

module.exports = ValidateUsername
